import React from "react";
import Finishes from './finishes.component';
//const AllFinishes = require("../../../data/finishes.data"); -> allFinishesUpdated

interface Props {
  propertyType: any;
  finishesRail: any;
  finishesFloor: any;
  finishesMeson: any;
  finishesWoodwork: any;
  allFinishesUpdated: any;
  setFinishesRail: (value: any) => void;
  setFinishesFloor: (value: any) => void;
  setFinishesMeson: (value: any) => void;
  setFinishesWoodwork: (value: any) => void;
}

const SidebarModules: React.FC<Props> = ({ propertyType, finishesRail, finishesFloor, finishesMeson, finishesWoodwork, allFinishesUpdated, setFinishesRail, setFinishesFloor, setFinishesMeson, setFinishesWoodwork }) => {

  const [finishesList, setFinishesList] = React.useState<any>([]);
  const states: any = {
    finishesRail: {
      state: finishesRail,
      setter: setFinishesRail,
    },
    finishesWoodwork: {
      state: finishesWoodwork,
      setter: setFinishesWoodwork,
    },
    finishesMeson: {
      state: finishesMeson,
      setter: setFinishesMeson,
    },
    finishesFloor: {
      state: finishesFloor,
      setter: setFinishesFloor,
    }
  };

  React.useEffect(() => {
    if(propertyType.id){
      const finishesProperty = allFinishesUpdated[propertyType.id];
      for (const finishes of finishesProperty){
        const category = finishes.category;
        if(category === 'finishesRail'){
          setFinishesRail(finishes.options[0]);
        }else if(category === 'finishesWoodwork'){
          setFinishesWoodwork(finishes.options[0]);
        }else if(category === 'finishesMeson'){
          setFinishesMeson(finishes.options[0]);
        }else if(category === 'finishesFloor'){
          setFinishesFloor(finishes.options[0]);
        }
      }
      setFinishesList(finishesProperty);
    }
  }, [propertyType, allFinishesUpdated, setFinishesRail, setFinishesWoodwork, setFinishesMeson, setFinishesFloor]);

  return (
    <div className="tour-sidebar-finishes-container">
      <div className='tour-sidebar-finishes-container-title'>Acabados</div>
      { 
        finishesList.map( (local_finishes: any, index: number) => 
          <Finishes key={local_finishes.id} finishes={local_finishes} currentFinishes={states[local_finishes.category]['state']} setCurrentFinishes={states[local_finishes.category]['setter']}/>
        )
      }
    </div>
  );
};

export default SidebarModules;